import { Link } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { PageHeader } from 'shared/components/Feedback';

export function NotificationsPage() {
  const { t } = useI18n();
  return (
    <div>
      <PageHeader title={t('notifications.title')} />
      <p>{t('notifications.body')}</p>
      <p>
        <Link to={paths.legalDocuments}>{t('notifications.legalLink')}</Link>
      </p>
    </div>
  );
}
